export default [
    {
        path: '',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home'
    }
]



// WEBPACK FOOTER //
// ./src/router/home.js